import React from 'react'
import { useSelector } from 'react-redux'
import { IconContext } from 'react-icons'
import { IoMdWarning } from 'react-icons/io'
import { Form, Field, useFormikContext } from 'formik'
import PhoneInput from 'react-phone-number-input'
import 'react-phone-number-input/style.css'
import { Input } from '@wellbeingxltd/fe-lib/components'
import { GET_STORE } from '@wellbeingxltd/fe-lib/constants'
import { Button } from 'components'
import './styles.scss'

export const OnboardingForm = ({
    financePhone,
    isCompanyRegistered,
    isVATRegistered,
    primaryPhone,
    setFinancePhone,
    setIsCompanyRegistered,
    setIsVATRegistered,
    setPrimaryPhone,
}) => {
    const { loadingUpdateSupplier } = useSelector(GET_STORE.SUPPLIER)
    const { setTouched, setValues, setFieldTouched, setFieldValue, values, touched } = useFormikContext()

    return (
        <Form>
            <Field name="companyName">
                {({ field, meta }) => <Input touched={meta.touched} error={meta.error} {...field} labelAbove="Company name" required />}
            </Field>
            <Field name="tradingName">
                {({ field, meta }) => <Input touched={meta.touched} error={meta.error} {...field} labelAbove="Trading name" />}
            </Field>
            <Field name="firstLine">
                {({ field, meta }) => <Input touched={meta.touched} error={meta.error} {...field} labelAbove="Address line 1" required />}
            </Field>
            <Field name="secondLine">
                {({ field, meta }) => <Input touched={meta.touched} error={meta.error} {...field} labelAbove="Address line 2" />}
            </Field>
            <Field name="city">
                {({ field, meta }) => <Input touched={meta.touched} error={meta.error} {...field} labelAbove="City" required />}
            </Field>
            <Field name="postCode">
                {({ field, meta }) => <Input touched={meta.touched} error={meta.error} {...field} labelAbove="Postal code" required />}
            </Field>
            <Field name="country">
                {({ field, meta }) => <Input touched={meta.touched} error={meta.error} {...field} labelAbove="Country" required />}
            </Field>
            <Field name="primaryContactEmail">
                {({ field, form, meta }) => <Input type="email" touched={meta.touched} error={meta.error} {...field} labelAbove="Primary contact email" required onBlurCapture={e => form.setFieldValue(e.target.name, e.target.value.trim().toLowerCase())} />}
            </Field>
            <Field name="primaryContactPhone">
                {({ meta }) => (
                    <div className="input-container">
                        <label className="input-label">
                            Primary contact phone<span>*</span>
                        </label>
                        <PhoneInput
                            value={primaryPhone}
                            onChange={phoneInE164Format => {
                                setTouched({ ...touched, primaryContactPhone: true })
                                setValues({ ...values, primaryContactPhone: phoneInE164Format })
                                setPrimaryPhone(phoneInE164Format)
                            }}
                            onBlur={() => {
                                setTouched({ ...touched, primaryContactPhone: true })
                            }}
                        />
                        {meta.error && meta.touched && <div className="input-error-label">{meta.error}</div>}
                    </div>
                )}
            </Field>
            <Field name="financeEmail">
                {({ field, form, meta }) => (
                    <Input
                        touched={meta.touched}
                        type="email"
                        error={meta.error}
                        {...field}
                        labelAbove="Finance email (can be the same as the primary contact email)"
                        required
                        onBlurCapture={e => form.setFieldValue(e.target.name, e.target.value.trim().toLowerCase())}
                    />
                )}
            </Field>

            <Field name="financePhone">
                {({ meta }) => (
                    <div className="input-container">
                        <label className="input-label">
                            Finance phone<span>*</span>
                        </label>
                        <PhoneInput
                            value={financePhone}
                            onChange={phoneInE164Format => {
                                setTouched({ ...touched, financePhone: true })
                                setValues({ ...values, financePhone: phoneInE164Format })
                                setFinancePhone(phoneInE164Format)
                            }}
                            onBlur={() => {
                                setTouched({ ...touched, financePhone: true })
                            }}
                        />
                        {meta.error && meta.touched && <div className="input-error-label">{meta.error}</div>}
                    </div>
                )}
            </Field>
            <Field name="accountsPayableEmail">
                {({ field, form, meta }) => <Input type="email" touched={meta.touched} error={meta.error} {...field} labelAbove="Accounts payable email" required onBlurCapture={e => form.setFieldValue(e.target.name, e.target.value.trim().toLowerCase())} />}
            </Field>

            <Field name="companyRegNumber">
                {({ field, meta }) => (
                    <Input
                        touched={meta.touched}
                        error={meta.error}
                        {...field}
                        labelAbove="Company reg number"
                        disabled={!isCompanyRegistered}
                        value={field.value}
                        required
                    />
                )}
            </Field>

            <Input
                className="registerCheckbox"
                type="checkbox"
                labelAbove="Company not registered"
                onChange={event => {
                    setIsCompanyRegistered(!event.target.checked)
                    setFieldValue('companyRegNumber', event.target.checked ? 'n/a' : '')
                    setTimeout(() => setFieldTouched('companyRegNumber', true))
                }}
            />

            <Field name="vatRegNumber">
                {({ field, meta }) => (
                    <Input
                        touched={meta.touched}
                        error={meta.error}
                        {...field}
                        labelAbove="VAT number"
                        disabled={!isVATRegistered}
                        value={field.value}
                        required
                    />
                )}
            </Field>

            <Input
                className="registerCheckbox"
                type="checkbox"
                labelAbove="Not VAT registered"
                onChange={event => {
                    setIsVATRegistered(!event.target.checked)
                    setFieldValue('vatRegNumber', event.target.checked ? 'n/a' : '')
                    setTimeout(() => setFieldTouched('vatRegNumber', true))
                }}
            />

            <br />
            <p className="p--withIcon">
                <IconContext.Provider value={{ className: 'warningIcon' }}>
                    <IoMdWarning />
                </IconContext.Provider>
                After saving your details you will be redirected to Stripe to set up your Stripe Connected Account. Please note that we currently only
                accept UK bank accounts.
            </p>
            <Button loading={loadingUpdateSupplier} type="submit" className="landing-card-button">
                SAVE
            </Button>
        </Form>
    )
}
